import React from 'react';
import { Container, Row, Col, FormGroup, Label, Input, Form, Button } from 'reactstrap';
import { colors } from '../Utils/Colors';
import { changePassword, changePasswordFailure, changePasswordSuccess } from '../Actions/userAction';
import { connect } from 'react-redux';
import { serverUrls } from '../Utils/Urls';
import axios from 'axios';

class ChangePassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            oldPassword: '',
            newPassword: ''
        }
        this.onChange = this.onChange.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    changePassword(e) {
        e.preventDefault();
        this.props.submit(this.state);
    }

    render() {
        return (
            <div>
                <Container style={{maxWidth: 400, border:'1px solid '+colors.lightGrey , textAlign: "left"}}>
                    <br/>
                    <h3>Change Password</h3>
                    <br/>
                    <Form onKeyPress={e => e.key === 'Enter' && this.changePassword(e)}>
                        <Row form>
                            <Col md={12}>
                            <FormGroup>
                                <Label for="oldPassword">Old Password</Label>
                                <Input value={this.state.oldPassword} onChange={this.onChange} type="password" name="oldPassword" id="oldPassword" placeholder="old password" />
                            </FormGroup>
                            </Col>
                            <Col md={12}>
                            <FormGroup>
                                <Label for="password">Password</Label>
                                <Input value={this.state.newPassword} onChange={this.onChange} type="password" name="newPassword" id="newPassword" placeholder="new password" />
                            </FormGroup>
                            </Col>
                        </Row>
                        <Button onClick={this.changePassword} >Change Password</Button>
                    </Form>
                    <br/>
                </Container>
                <div style={{textAlign: "center"}}>
                    <hr className="my-2" />
                    <p>Department of Endocrinology<br/>
                    Postgraduate Institute of Medical Education &amp; Research<br/>
                    Chandigarh, India - 160012</p>
                    <p className="lead">
                    </p>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        submit: (payload) => {
            dispatch(changePassword({loading: true}));
            axios.post(serverUrls.changePassword, payload).then((res)=>{
                dispatch(changePasswordSuccess({loading: false, success: res.data}));
            }).catch((err)=>{
                dispatch(changePasswordFailure({loading: false, errors: err.response.data}));
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
